import Matomo from './Matomo';

export default Matomo;
